import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import {
  Button,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  EditOutlined,
  DeleteOutline,
  Search,
  LocalOfferOutlined,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";

//Services
import promocodeApi from "Services/Promocode";

//Modals
import PassengerAddModal from "Pages/Modals/Promocode/Create";
import PassengerUpdateModal from "Pages/Modals/Promocode/Update";
import PassengerDeleteDialog from "Pages/Modals/Promocode/Delete";

const Promocode = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [customerId, setCustomerId] = useState("");

  //Pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(1);
  const [searchText, setSearchText] = useState("");

  //Modals
  const [addPassenderModal, setAddPassengerModal] = useState(false);
  const handleOpenAddPassengerModal = () => setAddPassengerModal(true);
  const handleCloseAddPassengerModal = () => {
    setAddPassengerModal(false);
    getPromocodes();
  };

  const [updatePassenderModal, setUpdatePassengerModal] = useState(false);
  const handleOpenUpdatePassengerModal = (row) => {
    setCustomerId(row?._id);
    setUpdatePassengerModal(true);
  };
  const handleCloseUpdatePassengerModal = () => {
    setUpdatePassengerModal(false);
    getPromocodes();
  };

  const [deletePassengerModal, setdeletePassengerModal] = useState(false);
  const handleOpenDeletePassengerModal = (row) => {
    setCustomerId(row?._id);
    setdeletePassengerModal(true);
  };
  const handleCloseDeleteServiceModal = () => {
    setdeletePassengerModal(false);
    getPromocodes();
  };

  // Get Promocodes list api
  const getPromocodes = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalRecords(res?.data?.data?.totalRecords || res?.data?.data?.data?.length || 1);
        setRow(res?.data?.data?.data || []);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      setRow([]);
    };
    const params = { page, limit: pageSize, search: "" };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    promocodeApi
      .getPromocodeList(params)
      .then(onSuccess, onFailure);
  }, [page, pageSize, demoaccount_id, dispatch]);

  const getallpromocodes = useCallback(() => {
    const onSuccess = (res) => {
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data || []);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = () => {
      setbulkrow([]);
    };
    const params = { page: 1, limit: "unlimited", search: "" };
    if (demoaccount_id) {
      params.demoaccount_id = demoaccount_id;
    }
    promocodeApi
      .getPromocodeList(params)
      .then(onSuccess, onFailure);
  }, [demoaccount_id]);

  useEffect(() => {
    getPromocodes();
    getallpromocodes();
  }, [getPromocodes, getallpromocodes]);

  const calculateSno = (pageIndex, pSize, index) => {
    return (pageIndex - 1) * pSize + index + 1;
  };

  const filteredRow = (row || []).filter((data) => {
    if (!searchText) return true;
    const searchLower = searchText.toLowerCase();
    return (
      (data?.promoCode || "").toLowerCase().includes(searchLower) ||
      `${data?.discount || ""}`.includes(searchLower) ||
      (data?.discountType || "").toLowerCase().includes(searchLower) ||
      (data?.discountUserType || "").toLowerCase().includes(searchLower) ||
      (data?.status || "").toLowerCase().includes(searchLower)
    );
  });

  const dataRows = _.map(filteredRow || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    promoCode: data?.promoCode || "-",
    discount: data?.discount ?? "-",
    discountType: data?.discountType || "-",
    discountUserType: data?.discountUserType || "-",
    startingAt: data?.startingAt,
    expiresAt: data?.expiresAt,
    status: data?.status || "-",
    use_count: data?.use_count ?? 0,
    row: data,
  }));

  const sourceBulk = bulkrow && bulkrow.length > 0 ? bulkrow : row;
  const bulkdataRows = _.map(
    _.orderBy(sourceBulk || [], ['createdAt'], ['asc']),
    (data, index) => ({
      sno: index + 1,
      promoCode: data?.promoCode || "-",
      discount: data?.discount ?? "-",
      discountType: data?.discountType || "-",
      discountUserType: data?.discountUserType || "-",
      startingAt: data?.startingAt && moment(data?.startingAt).isValid() ? moment(data?.startingAt).format("DD-MM-YYYY") : "-",
      expiresAt: data?.expiresAt && moment(data?.expiresAt).isValid() ? moment(data?.expiresAt).format("DD-MM-YYYY") : "-",
      status: data?.status || "-",
      use_count: data?.use_count ?? 0,
      row: data,
    })
  );

  const formatteddatas = dataRows.map((r) => ({
    "S.NO": r.sno,
    "Promo Code": r.promoCode,
    "Discount": r.discount,
    "Discount Type": r.discountType,
    "User Type": r.discountUserType,
    "Starting at": r.startingAt && moment(r.startingAt).isValid() ? moment(r.startingAt).format("DD-MM-YYYY") : "-",
    "Expiration": r.expiresAt && moment(r.expiresAt).format("DD-MM-YYYY") !== "Invalid date" ? moment(r.expiresAt).format("DD-MM-YYYY") : "-",
    "Status": r.status,
    "Usage Count": r.use_count,
  }));

  const handleDownloadAll = () => {
    const bulkformatteddatas = bulkdataRows.map((r) => ({
      "S.NO": r.sno,
      "Promo Code": r.promoCode,
      "Discount": r.discount,
      "Discount Type": r.discountType,
      "User Type": r.discountUserType,
      "Starting at": r.startingAt,
      "Expiration": r.expiresAt,
      "Status": r.status,
      "Usage Count": r.use_count,
    }));
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All PromocodeList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleCopy = () => {
    const columnWidths = [5, 15, 15, 15, 15, 15, 15, 15, 15];
    const padText = (text, width) => (text ?? "").toString().padEnd(width, " ");
    const header = [
      padText("S.NO", columnWidths[0]),
      padText("Promo Code", columnWidths[1]),
      padText("Discount", columnWidths[2]),
      padText("Discount Type", columnWidths[3]),
      padText("User Type", columnWidths[4]),
      padText("Starting at", columnWidths[5]),
      padText("Expiration", columnWidths[6]),
      padText("Status", columnWidths[7]),
      padText("Usage Count", columnWidths[8]),
    ].join("");

    const rows = dataRows
      .map((r) =>
        [
          padText(r.sno, columnWidths[0]),
          padText(r.promoCode, columnWidths[1]),
          padText(r.discount, columnWidths[2]),
          padText(r.discountType, columnWidths[3]),
          padText(r.discountUserType, columnWidths[4]),
          padText(r.startingAt && moment(r.startingAt).isValid() ? moment(r.startingAt).format("DD-MM-YYYY") : "-", columnWidths[5]),
          padText(r.expiresAt && moment(r.expiresAt).isValid() ? moment(r.expiresAt).format("DD-MM-YYYY") : "-", columnWidths[6]),
          padText(r.status, columnWidths[7]),
          padText(r.use_count, columnWidths[8]),
        ].join("")
      )
      .join("\n");

    const formattedContent = [header, rows].join("\n");
    navigator.clipboard.writeText(formattedContent).then(() => {
      dispatch(
        showSnackbar({
          message: "Copied table to clipboard!",
          variant: "success",
          autoHideDuration: 2000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        })
      );
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Promocodes");
    XLSX.writeFile(workbook, "PromocodeList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "PromocodeList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((r) => [
      r.sno,
      r.promoCode,
      r.discount,
      r.discountType,
      r.discountUserType,
      r.startingAt && moment(r.startingAt).isValid() ? moment(r.startingAt).format("DD-MM-YYYY") : "-",
      r.expiresAt && moment(r.expiresAt).isValid() ? moment(r.expiresAt).format("DD-MM-YYYY") : "-",
      r.status,
      r.use_count,
    ]);
    doc.autoTable({
      head: [["S.NO", "Promo Code", "Discount", "Discount Type", "User Type", "Starting at", "Expiration", "Status", "Usage Count"]],
      body: tableData,
    });
    doc.save("PromocodeList.pdf");
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setPage(1);
  };

  // Pagination Logic
  const totalPagesCount = Math.ceil(totalRecords / pageSize) || 1;

  const renderPagination = () => {
    let pages = [];
    const internalPage = page - 1;

    if (totalPagesCount <= 5) {
      for (let i = 0; i < totalPagesCount; i++) {
        pages.push(i);
      }
    } else {
      if (internalPage < 3) {
        pages = [0, 1, 2, "...", totalPagesCount - 1];
      } else if (internalPage > totalPagesCount - 4) {
        pages = [
          0,
          "...",
          totalPagesCount - 3,
          totalPagesCount - 2,
          totalPagesCount - 1,
        ];
      } else {
        pages = [
          0,
          "...",
          internalPage - 1,
          internalPage,
          internalPage + 1,
          "...",
          totalPagesCount - 1,
        ];
      }
    }

    return pages.map((item, index) => {
      if (item === "...") {
        return (
          <span key={index} className={classes.pageDots}>
            ...
          </span>
        );
      }

      return (
        <Button
          key={item}
          className={
            internalPage === item
              ? classes.pageButtonActive
              : classes.pageButton
          }
          onClick={() => setPage(item + 1)}
        >
          {item + 1}
        </Button>
      );
    });
  };

  const renderStatusBadge = (statusStr) => {
    const upper = (statusStr || "").toUpperCase();
    let badgeClass = classes.statusBadgeInactive;
    if (upper === "VALID" || upper === "ACTIVE") {
      badgeClass = classes.statusBadgeActive;
    } else if (upper === "UPCOMING") {
      badgeClass = classes.statusBadgeUpcoming;
    } else if (upper === "EXPIRED" || upper === "INACTIVE") {
      badgeClass = classes.statusBadgeExpired;
    }

    const formattedStatus = statusStr
      ?.toLowerCase()
      .split(/[\s_]+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

    return (
      <span className={badgeClass}>
        {formattedStatus || statusStr}
      </span>
    );
  };

  return (
    <Box className={classes.root}>
      {/* Header Container */}
      <Box className={classes.headerContainer}>
        <Typography className={classes.pageTitle}>Promo Code</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Promo Code</span>
        </Typography>
      </Box>

      {/* Actions and Search Bar Row */}
      <Box className={classes.actionRow}>
        <Box className={classes.searchWrapper}>
          <Search className={classes.searchIcon} />
          <input
            type="text"
            placeholder="Search"
            value={searchText}
            onChange={handleSearchChange}
            className={classes.searchInput}
          />
        </Box>

        <Box style={{ display: "flex", gap: "16px", alignItems: "center" }}>
          {/* Download/Copy bar */}
          <Box className={classes.exportGroup}>
            <Button className={classes.exportButton} onClick={handleCopy}>
              Copy
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadExcel}>
              Excel
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadCSV}>
              CSV
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadPDF}>
              PDF
            </Button>
            <Button className={classes.exportButton} onClick={handleDownloadAll}>
              Download All
            </Button>
          </Box>

          {!demoaccount_id && (
            <Button
              variant="contained"
              className={classes.addCustomerButton}
              onClick={handleOpenAddPassengerModal}
              startIcon={<LocalOfferOutlined />}
            >
              Add Promocode
            </Button>
          )}
        </Box>
      </Box>

      {/* Data Table */}
      <TableContainer component={Paper} elevation={0} className={classes.tableWrapper}>
        <Table>
          <TableHead>
            <TableRow className={classes.tableHeaderRow}>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 0.5 }}>
                S.No
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1.5 }}>
                Promo Code
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1 }}>
                Discount
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1.2 }}>
                Discount Type
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1.2 }}>
                User Type
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1.2 }}>
                Starting At
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1.2 }}>
                Expiration
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1 }}>
                Status
              </TableCell>
              <TableCell className={classes.tableHeaderCell} style={{ flex: 1 }}>
                Usage Count
              </TableCell>
              {!demoaccount_id && (
                <TableCell className={classes.tableHeaderCell} style={{ flex: 1.5, textAlign: "right" }}>
                  Actions
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataRows.map((rowItem) => (
              <TableRow key={rowItem.sno} className={classes.tableRow}>
                <TableCell className={classes.tableCell} style={{ flex: 0.5 }}>
                  {rowItem.sno}
                </TableCell>
                <TableCell
                  className={`${classes.tableCell} ${classes.boldText}`}
                  style={{ flex: 1.5 }}
                >
                  {rowItem.promoCode}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1 }}>
                  {rowItem.discount}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1.2 }}>
                  {rowItem.discountType
                    ?.toLowerCase()
                    .split(/[\s_]+/)
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1.2 }}>
                  {rowItem.discountUserType
                    ?.toLowerCase()
                    .split(/[\s_]+/)
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1.2 }}>
                  {rowItem.startingAt && moment(rowItem.startingAt).isValid() ? moment(rowItem.startingAt).format("DD-MM-YYYY") : "-"}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1.2 }}>
                  {rowItem.expiresAt && moment(rowItem.expiresAt).isValid() ? moment(rowItem.expiresAt).format("DD-MM-YYYY") : "-"}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1 }}>
                  {renderStatusBadge(rowItem.status)}
                </TableCell>
                <TableCell className={classes.tableCell} style={{ flex: 1 }}>
                  {rowItem.use_count}
                </TableCell>
                {!demoaccount_id && (
                  <TableCell className={classes.tableCell} style={{ flex: 1.5, textAlign: "right", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <Box
                      component="span"
                      className={classes.actionButton}
                      onClick={() => handleOpenUpdatePassengerModal(rowItem.row)}
                    >
                      <EditOutlined fontSize="small" /> Edit
                    </Box>
                    <Box
                      component="span"
                      className={classes.actionDeleteButton}
                      onClick={() => handleOpenDeletePassengerModal(rowItem.row)}
                    >
                      <DeleteOutline fontSize="small" /> Delete
                    </Box>
                  </TableCell>
                )}
              </TableRow>
            ))}
            {dataRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={demoaccount_id ? 9 : 10} style={{ textAlign: "center", padding: "32px" }}>
                  <Typography variant="body2" color="textSecondary">
                    No records found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <Box className={classes.paginationContainer}>
          <Typography className={classes.paginationText}>
            Showing {(page - 1) * pageSize + (dataRows.length > 0 ? 1 : 0)} to{" "}
            {Math.min(page * pageSize, totalRecords)} of {totalRecords} results
          </Typography>

          <Box className={classes.paginationControls}>
            <ChevronLeft
              className={`${classes.pageArrow} ${page === 1 ? "disabled" : ""}`}
              onClick={() => page > 1 && setPage(page - 1)}
            />

            {renderPagination()}

            <ChevronRight
              className={`${classes.pageArrow} ${page === totalPagesCount ? "disabled" : ""}`}
              onClick={() => page < totalPagesCount && setPage(page + 1)}
            />
          </Box>
        </Box>
      </TableContainer>

      <PassengerAddModal
        openDialog={addPassenderModal}
        handleClose={handleCloseAddPassengerModal}
      />
      <PassengerUpdateModal
        openDialog={updatePassenderModal}
        id={customerId}
        handleClose={handleCloseUpdatePassengerModal}
      />
      <PassengerDeleteDialog
        openDialog={deletePassengerModal}
        id={customerId}
        handleClose={handleCloseDeleteServiceModal}
      />
    </Box>
  );
};

export default Promocode;

